import { core } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { TockGiftCardBulkOrderRequest } = protos;

export function bulkOrderGiftCards(request: core.TockGiftCardBulkOrderRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/gift/card/tock/bulk-purchase',
      request: TockGiftCardBulkOrderRequest.fromObject(request),
      type: ClowncarAppConstants.TOCK_GIFT_CARD_BULK_PURCHASE,
      toast: 'Bulk Purchase Sent!',
    },
  };
}
